"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const _ = require("lodash");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const NoResultsFound_1 = require("../no-results/NoResultsFound");
const Pagination_1 = require("../pagination/Pagination");
const PastDrawsScreenStyle_1 = require("./jss/PastDrawsScreenStyle");
class PastDrawsScreenList extends React.Component {
    constructor(props) {
        super(props);
        this.getPagination = (page, classes) => ((0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12, className: classes.centered }, { children: (0, jsx_runtime_1.jsx)(Pagination_1.default, { first: page.first, last: page.last, activePage: page.number, totalPages: page.totalPages, onSelect: this.props.getNextPage, maxButtons: 4, marginPagesDisplayed: 0 }) })));
        this.renderDrawsList = () => {
            const { classes, drawsPerPage, onCardClicked, draws, page, loading, t } = this.props;
            if (!loading && (_.isEmpty(page) || (page.number === 0 && draws.length === 0))) {
                return (0, jsx_runtime_1.jsx)(NoResultsFound_1.default, { title: t('draws.noResultsFound') });
            }
            return ((0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ container: true, spacing: 4 }, { children: [page && page.totalElements > drawsPerPage && this.getPagination(page, classes), draws.map((draw) => this.props.getDrawCard(draw, onCardClicked.bind(this, draw))), page && page.totalElements > drawsPerPage && this.getPagination(page, classes)] })));
        };
        this.state = {
            activePage: 1,
            itemsPerPage: props.drawsPerPage
        };
    }
    render() {
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { display: 'flex', flexDirection: 'column' } }, { children: [this.props.renderTitle(), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ container: true }, { children: this.renderDrawsList() }))] })));
    }
}
exports.default = (0, core_1.withTheme)((0, core_1.withStyles)(PastDrawsScreenStyle_1.default)((0, react_i18next_1.withTranslation)()(PastDrawsScreenList)));
//# sourceMappingURL=past-draws-screen-list.js.map